import { Sparkles } from 'lucide-react';

const PRIORITY_HIGHLIGHTS = [
  'Furnished', 'Semi-Furnished', 'Swimming Pool', 'Solar Panels',
  'Parking (Covered)', 'Parking (Uncovered)', 'Elevator / Lift',
  'Central Air Conditioning', 'Gated Community', 'CCTV Security',
  'Rooftop Terrace', 'Lawn / Garden', 'Gymnasium / Gym', 'Balcony',
  'Built-in Wardrobes', 'Marble / Tile Flooring',
];

interface WhatsSpecialProps {
  property: any;
}

export function WhatsSpecial({ property }: WhatsSpecialProps) {
  const features = property.features || {};
  const all: string[] = [];
  if (typeof features === 'object' && !Array.isArray(features)) {
    Object.values(features).forEach((arr: any) => {
      if (Array.isArray(arr)) all.push(...arr);
    });
  }

  // Pick highlights in priority order, fall back to first available
  const ranked = PRIORITY_HIGHLIGHTS.filter(h => all.includes(h));
  const remaining = all.filter(a => !ranked.includes(a));
  const picks = [...ranked, ...remaining].slice(0, 4);

  if (picks.length === 0) return null;

  return (
    <div className="rounded-xl border border-primary/20 bg-gradient-to-br from-primary/5 to-transparent p-4 sm:p-5">
      <div className="flex items-center gap-2 mb-3">
        <Sparkles className="h-4 w-4 text-primary" />
        <h3 className="font-semibold text-sm">What's special</h3>
      </div>
      <div className="flex flex-wrap gap-2">
        {picks.map((p, i) => (
          <span
            key={i}
            className="inline-flex items-center rounded-full border border-primary/30 bg-background px-3 py-1 text-xs font-medium text-foreground"
          >
            {p}
          </span>
        ))}
      </div>
    </div>
  );
}
